import { Link } from 'react-router'
import type { LinkComponentProps } from '@concours/ui'

/** Adaptateur : la coque du design system utilise les liens de React Router. */
export function RouterLink({ href, children, ...rest }: LinkComponentProps) {
  return (
    <Link to={href} {...rest}>
      {children}
    </Link>
  )
}
